import { IPayments } from '../types/types';
import { Api } from './api';
import { AxiosResponse } from 'axios';

export const listPayments = <T>(
  page: number,
  limit: number,
  query?: string
): Promise<T> => {
  return Api().get(
    `/payments?page=${page}&limit=${limit}${query ? query : ''}`
  );
};

export const getAccountHolder = <T>(id: string): Promise<AxiosResponse<T>> => {
  return Api().get(`/payments/accountholder/${id}`);
};
export const initiatePayment = <T>(
  payload: Pick<IPayments, 'amount'> & { email: string }
): Promise<T> => {
  return Api().post(`/payments/initiate`, payload);
};

export const verifyPayment = <T>(transactionId: string): Promise<T> => {
  return Api().get(`/payments/verify?transactionId=${transactionId}`);
};

export const initiateMomoPayment = <T>(payload: {
  amount: number;
  network: string;
  msisdn: string;
  referenceNo: string;
  narration: string;
  callbackId?: string;
  payer: string;
  payee: string;
  sourceIdentifier: string;
}): Promise<T> => {
  return Api().post(`/payments/momo`, payload);
};

export const checkMomoPaymentStatus = <T>(referenceNo: string): Promise<T> => {
  return Api().get(`/payments/momo/status/${referenceNo}`);
};

export const creditTopUp = <T>(payload: {
  amount: number;
  recipientMsisdn: string;
}): Promise<T> => {
  const smsServiceEndpoint = '/payments/initiate';
  console.log(
    `Calling sms-service for credit top-up: POST ${smsServiceEndpoint}`
  );
  return Api().post(smsServiceEndpoint, payload);
};
